module.exports = __webpack_public_path__ + "img/kaguya houraisan_sc1.1734266b.png";